export class ErrorMessageData {
    public tollID?: string | null;
    public tonnageID?: string | null;
    public isReport?: boolean;
    public isInError?: boolean;

    constructor(errorMessageData: ErrorMessageData) {
        this.tollID = errorMessageData.tollID || null;
        this.tonnageID = errorMessageData.tonnageID || null;
        this.isReport = errorMessageData.isReport;
        this.isInError = errorMessageData.isInError;
    }
}
